import React, { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import Select, { MultiValue } from "react-select";
import { Link } from "react-router-dom";
import {
  deleteEvent,
  getEventDetail,
  getEvents,
  updateEventTime,
} from "./calendarAPI";
import {
  listAccountsOption,
  listContactsOptionn,
  listLeadsOption,
  listOpportunitiesOption,
  userList,
} from "../leads/logcall_api";
import { createEvent, updateEvent } from "../leads/event_api";
import {
  selectAssignType,
  selectRelatedToType,
} from "../../../core/common/selectoption/selectoption";
import { showSuccessMessage } from "../../../core/common/message";
import { Modal } from "react-bootstrap";
import { DeleteOutlined } from "@ant-design/icons";
import Loading from "../../../core/common/loading";

type FilterType = {
  from: Date | null;
  to: Date | null;
};

type EventType = {
  id?: number | null;
  uuid: string;
  subject: string;
  startTime: Date | null;
  endTime: Date | null;
  description: string;
  attendees: number[];
};

interface LeadListDTO {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company: string;
  phone: string;
  email: string;
  leadStageId: number;
  leadStatus: string;
  createdDate: string;
  leadOwner: string;
}
interface ContactlListDTO {
  contactId: number;
  contactName: string;
}
interface OpportunityListDTO {
  id: number;
  name: string;
}
interface AccountListDTO {
  accountId: number;
  accountName: string;
}
interface UserCall {
  id: number;
  uuid: string;
  username: string;
  role: string;
}

interface EventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}

const formatDateForInput = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const defaultEventError = {
  subject: "",
  attendees: "",
  startTime: "",
  endTime: "",
};

const defaultEventData = {
  subject: "",
  description: "",
  attendees: [] as number[],
  location: "",
  targetType: "",
  targetIds: null as number | null,
  assignType: "",
  assigneeId: [] as number[],
  startTime: "",
  endTime: "",
}

const Calendar = () => {
  const [listLeadAssignType, setListLeadAssignType] = useState<LeadListDTO[]>(
    []
  );
  const [listContactAssignType, setListContactAssignType] = useState<
    ContactlListDTO[]
  >([]);
  const [listAccountRelatedToType, setListAccountRelatedToType] = useState<
    AccountListDTO[]
  >([]);
  const [listOpportunitiesRelatedToType, setListOpportunitiesRelatedToType] =
    useState<OpportunityListDTO[]>([]);
  const [listUserCall, setListUserCall] = useState<UserCall[]>([]);
  const [assignTaskOptions, setAssignTaskOptions] = useState<
    { value: number; label: string }[]
  >([]);
  const [relateTaskOptions, setRelateTaskOptions] = useState<
    { value: number; label: string }[]
  >([]);

  const [filter, setFilter] = useState<FilterType>();
  const [events, setEvents] = useState([]);
  const [loadingType, setLoadingType] = useState({
    events: false,
    listUserCall: false,
    listLeadAssignType: false,
    listContactAssignType: false,
    listAccountRelatedToType: false,
    listOpportunitiesRelatedToType: false,
    addEvent: false,
    detailEvent: false,
    updateEvent: false,
    deleteEvent: false,
  });
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<{
    id: string;
    title: string;
    remove: () => void;
  } | null>(null);
  const modalRef = useRef<HTMLInputElement>(null);
  const [eventError, setEventError] = useState(defaultEventError);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [attendees, setAttendees] = useState<
    { value: number; label: string }[]
  >([]);
  const [newEventData, setNewEventData] = useState(defaultEventData);
  const [editEventData, setEditEventData] = useState(defaultEventData);
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);

  // fetch data
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoadingType((prev) => ({ ...prev, events: true }));
        const userId = localStorage.getItem("userId");
        const { data } = await getEvents(filter);
        setEvents(
          data.data.map((event: EventType) => ({
            id: String(event.id),
            title: event.subject,
            start: event.startTime,
            end: event.endTime,
            className: event?.attendees?.includes(Number(userId)) ? "bg-success" : "bg-info",
          }))
        );
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoadingType((prev) => ({ ...prev, events: false }));
      }
    };
    fetchEvents();
  }, [filter, reload]);

  useEffect(() => {
    const fetchUserCallList = async () => {
      console.log("fetchUserCallList");
      
      try {
        setLoadingType((prev) => ({ ...prev, listUserCall: true }));
        const userTenantId = Number(localStorage.getItem("userTenantId"));
        const response = await userList(userTenantId);
        setListUserCall(response.data.data || []);
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoadingType((prev) => ({ ...prev, listUserCall: false }));
      }
    };
    fetchUserCallList();
  }, []);

  useEffect(() => {
    const fetchListLeadAssignType = async () => {
      try {
        console.log("fetchListLeadALl Logcall...");
        
        setLoadingType((prev) => ({ ...prev, listLeadAssignType: true }));
        const response = await listLeadsOption();
        setListLeadAssignType(response.data.data || []);
      } catch (err) {
        console.error("Error fetching leads: ", err);
      } finally {
        setLoadingType((prev) => ({ ...prev, listLeadAssignType: false }));
      }
    };
    fetchListLeadAssignType();
  }, []);

  useEffect(() => {
    const fetchListContactAssignType = async () => {
      try {
        setLoadingType((prev) => ({ ...prev, listContactAssignType: true }));
        const response = await listContactsOptionn();
        setListContactAssignType(response.data.data || []);
      } catch (err) {
        console.error("Error fetching contacts: ", err);
      } finally {
        setLoadingType((prev) => ({ ...prev, listContactAssignType: false }));
      }
    };
    fetchListContactAssignType();
  }, []);

  useEffect(() => {
    const fetchAccountRelatedToType = async () => {
      try {
        setLoadingType((prev) => ({ ...prev, listAccountRelatedToType: true }));
        const response = await listAccountsOption();
        setListAccountRelatedToType(response.data.data || []);
      } catch (err) {
        console.error("Error fetching accounts: ", err);
      } finally {
        setLoadingType((prev) => ({
          ...prev,
          listAccountRelatedToType: false,
        }));
      }
    };
    fetchAccountRelatedToType();
  }, []);

  useEffect(() => {
    const fetchListOpportunitiesRelatedToType = async () => {
      try {
        setLoadingType((prev) => ({
          ...prev,
          listOpportunitiesRelatedToType: true,
        }));
        const response = await listOpportunitiesOption();
        setListOpportunitiesRelatedToType(response.data.data || []);
      } catch (err) {
        console.error("Error fetching opportunities: ", err);
      } finally {
        setLoadingType((prev) => ({
          ...prev,
          listOpportunitiesRelatedToType: false,
        }));
      }
    };
    fetchListOpportunitiesRelatedToType();
  }, []);
  // finish fetching data

  useEffect(() => {
    Object.values(loadingType).some((loading) => loading)
      ? setLoading(true)
      : setLoading(false);
  }, [loadingType]);

  const attendeesOptions = listUserCall.map((user) => ({
    value: user.id,
    label: user.username,
  }));

  const selectedAttendees = attendeesOptions.filter((option) =>
    editEventData.attendees.includes(option.value)
  );

  const handleSelectAttendeesChange = (selectedOptions: any) => {
    setEventError((prev) => ({ ...prev, attendees: "" }));
    setAttendees(selectedOptions);
    setNewEventData((prevData) => ({
      ...prevData,
      attendees: selectedOptions
        ? selectedOptions.map((option: { value: number }) => option.value)
        : [],
    }));
    setEditEventData({
      ...editEventData,
      attendees: selectedOptions.map((option: { value: number }) =>
        Number(option.value)
      ),
    });
  };

  const getNewEventData = (): EventDTO => {
    return {
      subject: newEventData.subject,
      description: newEventData.description,
      attendees: newEventData.attendees,
      location: newEventData.location,
      startTime: newEventData.startTime
        ? new Date(new Date(newEventData.startTime).getTime()).toISOString()
        : new Date().toISOString(),
      endTime: newEventData.endTime
        ? new Date(new Date(newEventData.endTime).getTime()).toISOString()
        : new Date().toISOString(),
      assignType: newEventData.assignType,
      assigneeId: newEventData.assigneeId,
      targetType: newEventData.targetType,
      targetIds: newEventData.targetIds,
    };
  };
  const getEditEventData = (): EventDTO => {
    return {
      subject: editEventData.subject,
      description: editEventData.description,
      attendees: editEventData.attendees,
      location: editEventData.location,
      startTime: editEventData.startTime
        ? new Date(new Date(editEventData.startTime).getTime()).toISOString()
        : new Date().toISOString(),
      endTime: editEventData.endTime
        ? new Date(new Date(editEventData.endTime).getTime()).toISOString()
        : new Date().toISOString(),
      assignType: editEventData.assignType,
      assigneeId: editEventData.assigneeId,
      targetType: editEventData.targetType,
      targetIds: editEventData.targetIds,
    };
  };

  const resetNewEventForm = () => {
    setNewEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: "",
    });
  };

  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("width-100"));
  }, []);

  const handleDateSelect = (selectInfo: any) => {};

  const handleAssignTypeChange = (selectedType: string) => {
    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "LEAD") {
      newOptions = listLeadAssignType.map((t) => ({
        value: t.leadId,
        label: t.leadName,
      }));
    } else if (selectedType === "CONTACT") {
      newOptions = listContactAssignType.map((t) => ({
        value: t.contactId,
        label: t.contactName,
      }));
    }
    setAssignTaskOptions(newOptions);
    setNewEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value }),
    }));
    setEditEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value }),
    }));
  };

  const handleTaskAssignTypeChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    handleAssignTypeChange(e.target.value);
  };

  const handleTargetTypeChange = (selectedType: string) => {
    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "ACCOUNT") {
      newOptions = listAccountRelatedToType.map((t) => ({
        value: t.accountId,
        label: t.accountName,
      }));
    } else if (selectedType === "OPPORTUNITY") {
      newOptions = listOpportunitiesRelatedToType.map((t) => ({
        value: t.id,
        label: t.name,
      }));
    }
    setRelateTaskOptions(newOptions);
    setNewEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value }),
    }));
    setEditEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value }),
    }));
  };

  const handleTaskRelatedToTypeChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    handleTargetTypeChange(e.target.value);
  };

  const handleEventClick = async (clickInfo: any) => {
    const eventId = clickInfo.event.id;
    setSelectedEventId(Number(eventId));
    setSelectedEvent(clickInfo.event);
    const fetchEventDetail = async () => {
      try {
        setLoadingType((prev) => ({ ...prev, detailEvent: true }));
        const { data } = await getEventDetail(eventId);
        const eventData = data.data;
        setAttendees(eventData.attendees);
        handleAssignTypeChange(eventData.assignType);
        handleTargetTypeChange(eventData.targetType);
        setEditEventData({
          subject: eventData.subject,
          description: eventData.description,
          attendees:
            eventData.attendees !== null
              ? eventData.attendees.map((attendee: any) => attendee.id)
              : [],
          location: eventData.location,
          targetType: eventData.targetType,
          targetIds: eventData.targets?.id,
          assignType: eventData.assignType,
          assigneeId:
            eventData.assignee !== null
              ? eventData.assignee.map((assignee: any) => assignee.id)
              : [],
          startTime: formatDateForInput(eventData.startTime),
          endTime: formatDateForInput(eventData.endTime),
        });
      } catch (error) {
        console.error("Error fetching event detail:", error);
      } finally {
        setLoadingType((prev) => ({ ...prev, detailEvent: false }));
      }
    };
    await fetchEventDetail();
    setOpenEditModal(true);
  };

  const handleEventDrop = async (info: any) => {
    const updatedEvent = {
      startTime: info.event.start?.toISOString(),
      endTime: info.event.end?.toISOString(),
    };

    try {
      setLoadingType((prev) => ({ ...prev, updateEvent: true }));
      await updateEventTime(info.event.id, updatedEvent); // Example API call
      showSuccessMessage("Event updated successfully!");
    } catch (error) {
      console.error("Error updating event:", error);
      info.revert(); // Revert the event to its original position if the update fails
    } finally {
      setLoadingType((prev) => ({ ...prev, updateEvent: false }));
    }
  };

  useEffect(() => {
    setEventError(defaultEventError);
    setNewEventData(defaultEventData);
    setAttendees([]);
  }, [openAddModal]);

  useEffect(() => {
    setEventError(defaultEventError);
  }, [openEditModal]);

  const validateEvent = (eventData: any) => {
    let isValid = true;
    if (!eventData.subject) {
      setEventError((prev) => ({
        ...prev,
        subject: "Subject is required!",
      }));
      modalRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      // subjectRef.current?.focus();
      isValid = false;
    } else {
      setEventError((prev) => ({ ...prev, subject: "" }));
    }

    if (attendees.length === 0) {
      setEventError((prev) => ({
        ...prev,
        attendees: "Attendees are required!",
      }));
      isValid = false;
    } else {
      setEventError((prev) => ({ ...prev, attendees: "" }));
    }

    if (!eventData.startTime) {
      setEventError((prev) => ({
        ...prev,
        startTime: "Start time is required!",
      }));
      isValid = false;
    } else {
      setEventError((prev) => ({ ...prev, startTime: "" }));
    }

    if (!eventData.endTime) {
      setEventError((prev) => ({
        ...prev,
        endTime: "End time is required!",
      }));
      isValid = false;
    } else {
      if (eventData.startTime > eventData.endTime) {
        setEventError((prev) => ({
          ...prev,
          endTime: "End time must be after start time!",
        }));
        isValid = false;
      } else {
        setEventError((prev) => ({ ...prev, endTime: "" }));
      }
    }

    return isValid;
  };

  const handleCreateEvent = async () => {
    if (!validateEvent(newEventData)) return;
    try {
      setLoadingType((prev) => ({ ...prev, addEvent: true }));
      const newEvent = getNewEventData();
      await createEvent(newEvent);
      resetNewEventForm();
      setAttendees([]);
      showSuccessMessage("Event created successfully!");
      setOpenAddModal(false);
      setReload(!reload);
    } catch (err) {
      console.error("Error creating event:", err);
    } finally {
      setLoadingType((prev) => ({ ...prev, addEvent: false }));
    }
  };

  const handleUpdateEvent = async () => {
    if (!validateEvent(editEventData)) return;
    if (!selectedEventId) {
      return;
    }
    try {
      setLoadingType((prev) => ({ ...prev, updateEvent: true }));
      const editEvent = getEditEventData();
      await updateEvent(selectedEventId, editEvent);
      showSuccessMessage("Event updated successfully!");
      setOpenEditModal(false);
      setReload(!reload);
    } catch (err) {
      console.error("Error creating event:", err);
    } finally {
      setLoadingType((prev) => ({ ...prev, updateEvent: false }));
    }
  };

  const handleDeleteEvent = async () => {
    try {
      setLoadingType((prev) => ({ ...prev, deleteEvent: true }));
      await deleteEvent(selectedEvent?.id);
      selectedEvent?.remove();
      showSuccessMessage("Event deleted successfully!");
      setOpenDeleteModal(false);
      setReload(!reload);
    } catch (error) {
      console.error("Error deleting event:", error);
    } finally {
      setLoadingType((prev) => ({ ...prev, deleteEvent: false }));
    }
  };

  const addEventTsx = (
    <Modal show={openAddModal} onHide={() => setOpenAddModal(false)}>
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h5 className="modal-title">Add New Event</h5>
          <button
            type="button"
            className="btn btn-close position-static"
            onClick={() => setOpenAddModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Subject <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      eventError.subject ? "input-error" : ""
                    }`}
                    placeholder="Enter subject"
                    value={newEventData.subject}
                    onChange={(e) => {
                      setNewEventData({
                        ...newEventData,
                        subject: e.target.value,
                      });
                      setEventError((prev) => ({ ...prev, subject: "" }));
                    }}
                  />
                  {eventError.subject && (
                    <div className="error-message">{eventError.subject}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Enter description"
                    value={newEventData.description}
                    onChange={(e) =>
                      setNewEventData({
                        ...newEventData,
                        description: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter location"
                    value={newEventData.location}
                    onChange={(e) =>
                      setNewEventData({
                        ...newEventData,
                        location: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Attendees <span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti
                    className={eventError.attendees ? "input-error" : ""}
                    options={attendeesOptions}
                    value={attendees}
                    onChange={handleSelectAttendeesChange}
                    classNamePrefix="react-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "50px",
                        maxHeight: "none",
                        flexWrap: "wrap",
                        overflowY: "auto",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        flexWrap: "wrap",
                        maxHeight: "150px",
                        overflowY: "auto",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                  {eventError.attendees && (
                    <div className="error-message">{eventError.attendees}</div>
                  )}
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="col-form-label">Assign Type</label>
                    <select
                      className="form-control"
                      value={newEventData.assignType}
                      onChange={handleTaskAssignTypeChange}
                    >
                      <option value="">Select Assign Type</option>
                      {selectAssignType.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label">Assign</label>
                    <Select
                      isMulti
                      className="select2"
                      options={assignTaskOptions}
                      placeholder="Choose"
                      classNamePrefix="react-select"
                      value={assignTaskOptions.filter((option) =>
                        newEventData.assigneeId &&
                        Array.isArray(newEventData.assigneeId)
                          ? newEventData.assigneeId.includes(option.value)
                          : false
                      )}
                      onChange={(
                        selectedOptions: MultiValue<{
                          value: number;
                          label: string;
                        }>
                      ) =>
                        setNewEventData({
                          ...newEventData,
                          assigneeId:
                            selectedOptions.length > 0
                              ? selectedOptions.map((option) => option.value)
                              : [],
                        })
                      }
                      isDisabled={assignTaskOptions.length === 0}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          minHeight: "50px",
                          maxHeight: "none",
                          flexWrap: "wrap",
                          overflowY: "auto",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          flexWrap: "wrap",
                          maxHeight: "150px",
                          overflowY: "auto",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="col-form-label">Target Type</label>
                    <select
                      className="form-control"
                      value={newEventData.targetType}
                      onChange={handleTaskRelatedToTypeChange}
                    >
                      <option value="">Select Target Type</option>
                      {selectRelatedToType.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Target */}
                  <div className="col-md-6">
                    <label className="col-form-label">Target</label>
                    <Select
                      className="select2"
                      options={relateTaskOptions}
                      placeholder="Choose"
                      classNamePrefix="react-select"
                      value={
                        relateTaskOptions.find(
                          (option) => option.value === newEventData.targetIds
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setNewEventData({
                          ...newEventData,
                          targetIds: selectedOption?.value || 0,
                        })
                      }
                      isDisabled={relateTaskOptions.length === 0}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="col-form-label">
                      Start Time <span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${
                        eventError.startTime ? "input-error" : ""
                      }`}
                      value={newEventData.startTime}
                      onChange={(e) => {
                        setNewEventData({
                          ...newEventData,
                          startTime: e.target.value,
                        });
                        setEventError((prev) => ({ ...prev, startTime: "" }));
                      }}
                    />
                    {eventError.startTime && (
                      <div className="error-message">
                        {eventError.startTime}
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 mt-3">
                    <label className="col-form-label">
                      End Time <span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${
                        eventError.endTime ? "input-error" : ""
                      }`}
                      value={newEventData.endTime}
                      onChange={(e) => {
                        setNewEventData({
                          ...newEventData,
                          endTime: e.target.value,
                        });
                        setEventError((prev) => ({ ...prev, endTime: "" }));
                      }}
                    />
                    {eventError.endTime && (
                      <div className="error-message">{eventError.endTime}</div>
                    )}
                  </div>
                </div>
                <div className="text-end modal-btn mt-3">
                  <button
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    type="button"
                    onClick={handleCreateEvent}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );

  const updateEventTsx = (
    <Modal show={openEditModal} onHide={() => setOpenEditModal(false)}>
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h5 className="modal-title">Event Details</h5>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setOpenEditModal(false);
              setOpenDeleteModal(true);
            }}
            style={{ marginLeft: "10px" }}
          >
            {" "}
            <DeleteOutlined style={{ color: "white", fontSize: "16px" }} />
          </button>
          <button
            type="button"
            className="btn-close position-static"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => setOpenEditModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Subject <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      eventError.subject ? "input-error" : ""
                    }`}
                    placeholder="Enter subject"
                    value={editEventData.subject}
                    onChange={(e) => {
                      setEditEventData({
                        ...editEventData,
                        subject: e.target.value,
                      });
                      setEventError((prev) => ({ ...prev, subject: "" }));
                    }}
                  />
                  {eventError.subject && (
                    <div className="error-message">{eventError.subject}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Enter description"
                    value={editEventData.description}
                    onChange={(e) =>
                      setEditEventData({
                        ...editEventData,
                        description: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter location"
                    value={editEventData.location}
                    onChange={(e) =>
                      setEditEventData({
                        ...editEventData,
                        location: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Attendees <span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti
                    className={eventError.attendees ? "input-error" : ""}
                    options={attendeesOptions}
                    value={selectedAttendees}
                    onChange={handleSelectAttendeesChange}
                    classNamePrefix="react-select"
                  />
                  {eventError.attendees && (
                    <div className="error-message">{eventError.attendees}</div>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="col-form-label">Assign Type</label>
                    <select
                      className="form-control"
                      value={editEventData.assignType}
                      onChange={handleTaskAssignTypeChange}
                    >
                      <option value="">Select Assign Type</option>
                      {selectAssignType.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label">Assign</label>
                    <Select
                      isMulti
                      className="select2"
                      options={assignTaskOptions}
                      placeholder="Choose"
                      classNamePrefix="react-select"
                      value={assignTaskOptions.filter((option) =>
                        editEventData.assigneeId.includes(option.value)
                      )}
                      onChange={(
                        selectedOptions: MultiValue<{
                          value: number;
                          label: string;
                        }>
                      ) =>
                        setEditEventData({
                          ...editEventData,
                          assigneeId: selectedOptions.map(
                            (option) => option.value
                          ),
                        })
                      }
                      isDisabled={assignTaskOptions.length === 0}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          minHeight: "50px",
                          maxHeight: "auto",
                          overflowY: "auto",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="col-form-label">Target Type</label>
                    <select
                      className="form-control"
                      value={editEventData?.targetType}
                      onChange={handleTaskRelatedToTypeChange}
                    >
                      <option value="">Select Target Type</option>
                      {selectRelatedToType.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Target */}
                  <div className="col-md-6">
                    <label className="col-form-label">Target</label>
                    <Select
                      className="select2"
                      options={relateTaskOptions}
                      placeholder="Choose"
                      classNamePrefix="react-select"
                      value={relateTaskOptions.find(
                        (option) => option.value === editEventData.targetIds
                      )}
                      onChange={(selectedOption) =>
                        setEditEventData({
                          ...editEventData,
                          targetIds: selectedOption?.value || 0,
                        })
                      }
                      isDisabled={relateTaskOptions.length === 0}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12 mb-3">
                    <label className="col-form-label">
                      Start Time <span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${
                        eventError.startTime ? "input-error" : ""
                      }`}
                      value={editEventData.startTime}
                      onChange={(e) => {
                        setEditEventData({
                          ...editEventData,
                          startTime: e.target.value,
                        });
                        setEventError((prev) => ({ ...prev, startTime: "" }));
                      }}
                    />
                    {eventError.startTime && (
                      <div className="error-message">
                        {eventError.startTime}
                      </div>
                    )}
                  </div>
                  <div className="col-md-12">
                    <label className="col-form-label">
                      End Time <span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${
                        eventError.endTime ? "input-error" : ""
                      }`}
                      value={editEventData.endTime}
                      onChange={(e) => {
                        setEditEventData({
                          ...editEventData,
                          endTime: e.target.value,
                        });
                        setEventError((prev) => ({ ...prev, endTime: "" }));
                      }}
                    />
                    {eventError.endTime && (
                      <div className="error-message">{eventError.endTime}</div>
                    )}
                  </div>
                </div>
                <div className="text-end modal-btn mt-3">
                  <button
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    type="button"
                    onClick={() => setOpenEditModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    type="button"
                    onClick={handleUpdateEvent}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );

  const deleteEventTsx = (
    <div>
      <Modal
        show={openDeleteModal}
        onHide={() => setOpenDeleteModal(false)}
        centered
      >
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove event?</h4>
            <p className="mb-0">
              Are you sure you want to delete <br /> the event '
              {editEventData ? editEventData.subject : ""}'
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Link
                to="#"
                className="btn btn-light me-2"
                onClick={() => setOpenDeleteModal(false)}
              >
                Cancel
              </Link>
              <Link
                onClick={handleDeleteEvent}
                to="#"
                className="btn btn-danger"
                data-bs-dismiss="modal"
              >
                Yes, Delete it
              </Link>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );

  return (
    <>
      <Loading loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row align-items-center w-100">
              <div className="col-lg-10 col-sm-12">
                <h3 className="page-title">Calendar</h3>
              </div>
              <div className="col-lg-2 col-sm-12 d-flex justify-content-end p-0">
                <Link
                  to="#"
                  className="btn btn-primary"
                  onClick={() => setOpenAddModal(true)}
                >
                  Add New Event
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="card bg-white">
                <div className="card-body">
                  <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    initialView="dayGridMonth"
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                    events={events}
                    select={handleDateSelect}
                    eventClick={(clickInfo: any) => handleEventClick(clickInfo)}
                    datesSet={(dateInfo) => {
                      setFilter({
                        from: dateInfo.start,
                        to: dateInfo.end,
                      });
                    }}
                    eventDrop={(info) => handleEventDrop(info)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {addEventTsx}
      {updateEventTsx}
      {deleteEventTsx}
    </>
  );
};

export default Calendar;
